import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as routes from '../../constants/routes';
const AdminLayout = ({ children }) => {
  return (
    <div className="flex-grow-1  position-relative">
      <Navbar bg="dark" variant="dark">
        <Link to={routes.ADMIN} className="navbar-brand">
          Admin
        </Link>
        <Nav className="mr-auto">
          <Link to={routes.ADMIN} className="nav-link">
            Users
          </Link>
          <Link to={routes.ADMIN_REPORTS} className="nav-link">
            Reports
          </Link>
        </Nav>
        <Link to={routes.ROOT} className="nav-link text-white" target="_blank">
          Website
        </Link>
      </Navbar>

      <div className="container">{children}</div>
    </div>
  );
};

export default AdminLayout;
